import styled from 'styled-components';
import AccountList from './AccountList';
import ThxImage from 'src/assets/images/thank_you.png';
import FadeAnimation from '../animation/FadeAnimation';

const HeartSection = () => {
  return (
    <article id="account">
      <FadeAnimation>
        <StyledSection>
          <h2>마음 전하실 곳</h2>
          <p>
            참석이 어려우신 분들을 위해
            <br />
            계좌번호를 기재하였습니다.
            <br />
            너그러운 마음으로 양해 부탁드립니다.
          </p>
          <AccountList />
        </StyledSection>
      </FadeAnimation>
      <FadeAnimation>
        <img src={ThxImage} alt="Thank you" />
      </FadeAnimation>
    </article>
  );
};

const StyledSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3rem;
  padding: 4rem 3rem;
  background-color: var(--main-background);

  & > h2,
  & > p {
    font-size: 1.8rem;
    line-height: 2.4rem;
    text-align: center;
  }

  & > p {
    font-size: 1.6rem;
  }
`;

export default HeartSection;
